module.exports = __webpack_public_path__ + "static/media/hero.8479829a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Heathbot/hero.jpg
// module id = 190
// module chunks = 0